import { Injectable } from '@angular/core';
import {CookieService} from 'ngx-cookie';

@Injectable()
export class CurrentDayService {

	private _date: Date;

	constructor(private cookieService: CookieService) {}

	get currentDay(): Date {
		const selectedDateCookie: string = this.cookieService.get('selectedDate');
		return selectedDateCookie ? new Date(selectedDateCookie) : new Date();
	}

	set currentDay(date: Date) {
		this._date = date;
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/current-day.service.ts